export default __webpack_public_path__ + "static/media/Accel-1.3ee1d9e6.png";